import { render } from "./ByTypes.vue?vue&type=template&id=20a7a248&scoped=true&ts=true"
import script from "./ByTypes.vue?vue&type=script&lang=ts"
export * from "./ByTypes.vue?vue&type=script&lang=ts"

import "./ByTypes.vue?vue&type=style&index=0&id=20a7a248&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a7a248"]])

export default __exports__